export const serviceOptions = (key, options = []) => {
  switch (key) {
    case 'CHANNEL_BUY':
      return options?.map((el) => ({
        label: el.channelBuyNameTh,
        value: el.channelBuyId,
        channelBuyType: el.channelBuyType,
      }));
    case 'STORE_TYPE_CODE':
      const storeOptions =
        options?.map((el) => ({
          label: el.storeName,
          value: el.storeId,
        })) || [];
      return [{ label: 'กรุณาเลือกสาขาที่ใช้บริการ', value: '99' }, ...storeOptions];
    case 'MOBILE_BRAND':
      return options?.map((el) => ({
        label: el.mobileBrandNameTh,
        value: el.mobileBrandId,
        mobileModels: el.mobileModels,
      }));
    case 'MOBILE_MODEL':
      const mobileModelOptions =
        options?.map((el) => ({
          label: el.mobileModelNameTh,
          value: el.mobileModelId,
          products: el.products,
        })) || [];
      return [{ label: 'กรุณาเลือกรุ่นโทรศัพท์', value: '99' }, ...mobileModelOptions];
    case 'PRODUCT':
      return options?.map((el) => ({
        label: el.productDescriptionTh,
        value: el.mapProductId,
        productFullName: el.productFullName,
        productImageUrl: el.productImageUrl,
      }));
    case 'CHANNEL_CLAIM':
      return options?.map((el) => ({
        label: el?.channelClaimNameLineOa,
        value: el?.channelClaimId,
        channelClaimCode: el?.channelClaimCode,
      }));
    case 'STORE_NAME':
      return options?.map((el) => ({
        label: el.storeName,
        value: el.storeId,
      }));
  }
};
